import { useFeatureGate } from '@statsig/react-bindings';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import {
  type Brand,
  DEFAULT_BRAND_BY_SURFACE,
  type Surface,
  resolveActiveBrand,
  useUpdateActiveBrand,
} from '@growtherapy/tailwind/react';

import { userTypeAtom } from '../../auth/state';
import { setDefaultFavicon } from '../../metadata';
import { arc2026Rebrand } from '../../statsig/gates';
import { UserType } from '../../types';

export function useSyncGrowBranding() {
  const userType = useAtomValue(userTypeAtom);
  const surface: Surface = userType === UserType.PROVIDER ? 'provider' : 'client';

  const updateActiveBrand = useUpdateActiveBrand(surface);
  const { value: arcRebrandActive } = useFeatureGate(arc2026Rebrand);

  useEffect(() => {
    const activeBrand = resolveActiveBrand();
    const expectedInitialBrand: Brand = arcRebrandActive ? 'arc' : DEFAULT_BRAND_BY_SURFACE[surface];

    if (activeBrand !== expectedInitialBrand) {
      updateActiveBrand(expectedInitialBrand);
      setDefaultFavicon(expectedInitialBrand);
    }
    // NOTE: Until the Arc rebrand is fully launched, this dependency array should have a single
    // listed dependency on the rebrand feature flag. After launch, this should be a zero-dependency
    // effect.
    //
    // This is a one time client-side initialization to ensure that the default branding that was
    // set on page load matches our expected default brand for this surface area.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [arcRebrandActive]);
}
